<template>
  <div v-loading="loading"
       element-loading-text="拼命加载中">
    <el-form class="search-box" ref="form" :model="form" :rules="rules">
      <el-form-item prop="order_number">
        <el-input
          ref="search"
          @focus="stopKeyborad"
          @blur="stopKeyborad"
          v-model="form.order_number"
          @keydown.enter.native.prevent="onSubmit"
          placeholder="扫描上架产品订单编号"
        >
          <el-button
            @click.prevent="onSubmit"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <!--    <div v-if="items.length>0">

          <div>
            <span style="font-weight: bold">订单编号: </span>{{ items[0].order_number }}
          </div>
          <div><span style="font-weight: bold">交易编号: </span>{{ items[0].transaction_no }}</div>

        </div>-->

    <el-row :gutter="6" v-if="items.length>0">
      <el-col :span="18">
        <div>

          <div>
            <span style="font-weight: bold">订单编号: </span>{{ items[0].order_number }}
          </div>
          <div><span style="font-weight: bold">交易编号: </span>{{ items[0].transaction_no }}</div>
        </div>
      </el-col>
      <el-col :span="6" v-if="partition_name">
        <div>{{ partition_name }} 区</div>
        <div style="color: #3a8ee6">{{ shelf_name }}</div>
      </el-col>
    </el-row>

    <el-checkbox-group v-model="checkboxGroup1">
      <template v-for="item of items_wait">
        <el-checkbox :label="item.id" :key="item.id">

          <div class="show">
            <div class="line">
              <el-row :gutter="10">
                <el-col :span="16">
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content bg-purple-light" style="color: #3967FF">
                        <p v-if="item.purchase !== null">采购单号: {{ item.purchase.purchase_no }}</p>
                        <p v-else>采购单号: 待补货</p>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="grid-content bg-purple"
                           style="color: #bd2c00">
                        <h3>多品编号</h3>
                        <p>{{ item.transaction_number }}</p>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="grid-content bg-purple-light">
                        <h3>数量</h3>
                        <p style="color:  #bd2c00">{{ item.quantity }}</p>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="grid-content bg-purple-light">
                        <h3>SKU</h3>
                        <p>{{ item.sku }}</p>
                      </div>
                    </el-col>
                    <!--            <el-col :span="12">
                                  <div class="grid-content bg-purple-light">
                                    <h3>商品中文名称</h3>
                                    <p>{{ item.product_name }}</p>
                                  </div>
                                </el-col>-->
                    <el-col :span="24">
                      <div class="grid-content bg-purple-light">
                        <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{
                            item.word
                          }}</span></p>
                      </div>
                    </el-col>
                    <el-col :span="24" v-if="item.remark!==null">
                      <div class="grid-content bg-purple-light">
                        <p>备注: {{ item.remark }}</p>
                      </div>
                    </el-col>
                    <el-col :span="24" v-if="item.shelf_id!==null">
                      <div class="grid-content bg-purple-light" style="color: #3967FF">
                        <p>货架号: {{ item.shelf.shelf_no }}</p>
                      </div>
                    </el-col>

                    <template v-else>
                      <el-col :span="24" v-if="item.history_shelf_id!==null">
                        <div class="grid-content bg-purple-light" style="color: #3967FF">
                          <p>历史货架号: {{ item.history_shelf.shelf_no }}</p>
                        </div>
                      </el-col>
                    </template>

                    <el-col :span="12">
                      <div class="grid-content bg-purple-light">
                        <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未验收</span></p>
                        <p v-else-if="item.status===1">状态: <span style="color: #55a532">完成</span></p>
                        <p v-else-if="item.status===2">状态: <span style="color: red">异常</span></p>
                        <p v-else-if="item.status===3">状态: <span style="color: #3a8ee6">已拣货</span></p>
                        <p v-else-if="item.status===4">状态: <span style="color: red">锁单</span></p>
                        <p v-else-if="item.status===5">状态: <span style="color: #94971b">作废</span></p>
                        <p v-else-if="item.status===6">状态: <span style="color: #eb0fd9">缺货</span></p>
                        <p v-else-if="item.status===7">状态: <span style="color: #f00">删除</span></p>
                        <p v-else-if="item.status===8">状态: <span style="color: #123723">报废</span></p>
                        <p v-else>状态: 其它</p>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple-light" style="color: #3967FF">
                        <div  style="color: #3967FF">
                          <p v-if=" item.sub_table && item.sub_table.country != null ">国家: {{ item.sub_table.country }} </p>
                          <p v-else>国家: 无</p>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="24" v-if="item.accept_at">
                      <div class="grid-content bg-purple-light">
                        <p>时间: {{ item.accept_at }} </p>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <img :src="item.image_url" alt="" width="100%" preview="1" preview-text='图片展示'>
                </el-col>
              </el-row>

            </div>
          </div>

        </el-checkbox>
      </template>


      <el-collapse v-model="activeNames">

        <el-collapse-item name="4" v-if="items_out_of_stock.length">
          <template slot="title">
            部分验收
            <div class="old-count">{{ items_out_of_stock.length }}</div>
          </template>

          <template v-for="item of items_out_of_stock">
            <!--            <el-checkbox  :label="item.id" :key="item.id" :disabled="item.shelf_id == null ">-->
            <el-checkbox  :label="item.id" :key="item.id" disabled>
              <div class="show">
                <div class="line">
                  <el-row :gutter="10">
                    <el-col :span="16">
                      <el-row>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <p v-if="item.purchase !== null">采购单号: {{ item.purchase.purchase_no }}</p>
                            <p v-else>采购单号: 待补货</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple"
                               style="color: #bd2c00">
                            <h3>多品编号</h3>
                            <p>{{ item.transaction_number }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <h3>数量</h3>
                            <p style="color:  #bd2c00">{{ item.quantity }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <h3>SKU</h3>
                            <p>{{ item.sku }}</p>
                          </div>
                        </el-col>

                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{
                                item.word
                              }}</span></p>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.remark!==null">
                          <div class="grid-content bg-purple-light">
                            <p>备注: {{ item.remark }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.shelf_id!==null">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <p>货架号: {{ item.shelf.shelf_no }}</p>
                          </div>
                        </el-col>

                        <template v-else>
                          <el-col :span="24" v-if="item.history_shelf_id!==null">
                            <div class="grid-content bg-purple-light" style="color: #3967FF">
                              <p>历史货架号: {{ item.history_shelf.shelf_no }}</p>
                            </div>
                          </el-col>
                        </template>

                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未验收</span></p>
                            <p v-else-if="item.status===1">状态: <span style="color: #55a532">完成</span></p>
                            <p v-else-if="item.status===2">状态: <span style="color: red">异常</span></p>
                            <p v-else-if="item.status===3">状态: <span style="color: #3a8ee6">已拣货</span></p>
                            <p v-else-if="item.status===4">状态: <span style="color: red">锁单</span></p>
                            <p v-else-if="item.status===5">状态: <span style="color: #94971b">作废</span></p>
                            <p v-else-if="item.status===6">状态: <span style="color: #eb0fd9">缺货</span></p>
                            <p v-else-if="item.status===7">状态: <span style="color: #f00">删除</span></p>
                            <p v-else-if="item.status===8">状态: <span style="color: #123723">报废</span></p>
                            <p v-else>状态: 其它</p>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <div  style="color: #3967FF">
                              <p v-if=" item.sub_table && item.sub_table.country != null ">国家: {{ item.sub_table.country }} </p>
                              <p v-else>国家: 无</p>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.accept_at">
                          <div class="grid-content bg-purple-light">
                            <p>时间: {{ item.accept_at }} </p>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <img :src="item.image_url" alt="" width="100%" preview="1" preview-text='图片展示'>
                    </el-col>
                  </el-row>
                  <div v-if="item.detail_items.length">
                    <span style="font-weight: bold">验收记录: </span>
                    <el-row style="width: 90%;display: flex;margin-left: 7%;text-align: center">
                      <el-col :span="7">数量</el-col>
                      <el-col :span="7">状态</el-col>
                      <el-col :span="7">备注</el-col>
                      <el-col :span="7">上架</el-col>
                      <!--                          <el-col :span="7">操作</el-col>-->
                    </el-row>
                    <div class="group_div">
                      <el-checkbox-group v-model="checkboxGroup2" >
                        <template v-for="ite of item.detail_items" >
                          <el-checkbox :label="ite.id" :key="ite.id" :disabled="ite.status=='异常'||ite.is_up=='是'" >
                            <el-row style="text-align: center;display: flex">
                              <el-col :span="7">{{ ite.quantity }}</el-col>
                              <el-col :span="7">{{ ite.status }}</el-col>
                              <el-col :span="7">{{ ite.remark }}</el-col>
                              <el-col :span="7">{{ ite.is_up }}</el-col>
                              <!--                                <el-col :span="7"><el-button
                                                                  v-if="ite.status == '完成' && ite.is_up == '否'"
                                                                  @click.native.prevent="putOnShelfSon(ite.id,item.id)"
                                                                  type="text"
                                                                  size="small">
                                                                上架
                                                              </el-button></el-col>-->
                            </el-row>
                          </el-checkbox>
                        </template>
                      </el-checkbox-group>
                    </div>
                    <div class="up_all_item">
                      <button @click="putOnShelfSons(item.detail_items)">按数量上架</button>
                    </div>
                  </div>
                </div>
              </div>
            </el-checkbox>
          </template>

        </el-collapse-item>

        <el-collapse-item name="1" v-if="items_finish.length">
          <template slot="title">
            在货架产品
            <div class="old-count">{{ items_finish.length }}</div>
          </template>

          <template v-for="item of items_finish">
            <el-checkbox :label="item.id" :key="item.id" disabled>

              <div class="show">
                <div class="line">
                  <el-row :gutter="10">
                    <el-col :span="16">
                      <el-row>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <p v-if="item.purchase !== null">采购单号: {{ item.purchase.purchase_no }}</p>
                            <p v-else>采购单号: 待补货</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple"
                               style="color: #bd2c00">
                            <h3>多品编号</h3>
                            <p>{{ item.transaction_number }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <h3>数量</h3>
                            <p style="color:  #bd2c00">{{ item.quantity }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <h3>SKU</h3>
                            <p>{{ item.sku }}</p>
                          </div>
                        </el-col>
                        <!--            <el-col :span="12">
                                      <div class="grid-content bg-purple-light">
                                        <h3>商品中文名称</h3>
                                        <p>{{ item.product_name }}</p>
                                      </div>
                                    </el-col>-->
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{
                                item.word
                              }}</span></p>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.remark!==null">
                          <div class="grid-content bg-purple-light">
                            <p>备注: {{ item.remark }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.shelf_id!==null">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <p>货架号: {{ item.shelf.shelf_no }}</p>
                          </div>
                        </el-col>

                        <template v-else>
                          <el-col :span="24" v-if="item.history_shelf_id!==null">
                            <div class="grid-content bg-purple-light" style="color: #3967FF">
                              <p>历史货架号: {{ item.history_shelf.shelf_no }}</p>
                            </div>
                          </el-col>
                        </template>

                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未验收</span></p>
                            <p v-else-if="item.status===1">状态: <span style="color: #55a532">完成</span></p>
                            <p v-else-if="item.status===2">状态: <span style="color: red">异常</span></p>
                            <p v-else-if="item.status===3">状态: <span style="color: #3a8ee6">已拣货</span></p>
                            <p v-else-if="item.status===4">状态: <span style="color: red">锁单</span></p>
                            <p v-else-if="item.status===5">状态: <span style="color: #94971b">作废</span></p>
                            <p v-else-if="item.status===6">状态: <span style="color: #eb0fd9">缺货</span></p>
                            <p v-else-if="item.status===7">状态: <span style="color: #f00">删除</span></p>
                            <p v-else-if="item.status===8">状态: <span style="color: #123723">报废</span></p>
                            <p v-else>状态: 其它</p>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <div  style="color: #3967FF">
                              <p v-if=" item.sub_table && item.sub_table.country != null ">国家: {{ item.sub_table.country }} </p>
                              <p v-else>国家: 无</p>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.accept_at">
                          <div class="grid-content bg-purple-light">
                            <p>时间: {{ item.accept_at }} </p>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <img :src="item.image_url" alt="" width="100%" preview="1" preview-text='图片展示'>
                    </el-col>
                  </el-row>

                </div>
              </div>

            </el-checkbox>
          </template>

        </el-collapse-item>

        <el-collapse-item name="2" v-if="items_unfinished.length">
          <template slot="title">
            未验收/异常/已发货
            <div class="old-count">{{ items_unfinished.length }}</div>
          </template>

          <template v-for="item of items_unfinished">
            <el-checkbox :label="item.id" :key="item.id" disabled>

              <div class="show">
                <div class="line">
                  <el-row :gutter="10">
                    <el-col :span="16">
                      <el-row>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <p v-if="item.purchase !== null">采购单号: {{ item.purchase.purchase_no }}</p>
                            <p v-else>采购单号: 待补货</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple"
                               style="color: #bd2c00">
                            <h3>多品编号</h3>
                            <p>{{ item.transaction_number }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <h3>数量</h3>
                            <p style="color:  #bd2c00">{{ item.quantity }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <h3>SKU</h3>
                            <p>{{ item.sku }}</p>
                          </div>
                        </el-col>
                        <!--            <el-col :span="12">
                                      <div class="grid-content bg-purple-light">
                                        <h3>商品中文名称</h3>
                                        <p>{{ item.product_name }}</p>
                                      </div>
                                    </el-col>-->
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{
                                item.word
                              }}</span></p>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.remark!==null">
                          <div class="grid-content bg-purple-light">
                            <p>备注: {{ item.remark }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.shelf_id!==null">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <p>货架号: {{ item.shelf.shelf_no }}</p>
                          </div>
                        </el-col>

                        <template v-else>
                          <el-col :span="24" v-if="item.history_shelf_id!==null">
                            <div class="grid-content bg-purple-light" style="color: #3967FF">
                              <p>历史货架号: {{ item.history_shelf.shelf_no }}</p>
                            </div>
                          </el-col>
                        </template>

                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未验收</span></p>
                            <p v-else-if="item.status===1">状态: <span style="color: #55a532">完成</span></p>
                            <p v-else-if="item.status===2">状态: <span style="color: red">异常</span></p>
                            <p v-else-if="item.status===3">状态: <span style="color: #3a8ee6">已拣货</span></p>
                            <p v-else-if="item.status===4">状态: <span style="color: red">锁单</span></p>
                            <p v-else-if="item.status===5">状态: <span style="color: #94971b">作废</span></p>
                            <p v-else-if="item.status===6">状态: <span style="color: #eb0fd9">缺货</span></p>
                            <p v-else-if="item.status===7">状态: <span style="color: #f00">删除</span></p>
                            <p v-else-if="item.status===8">状态: <span style="color: #123723">报废</span></p>
                            <p v-else>状态: 其它</p>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <div  style="color: #3967FF">
                              <p v-if=" item.sub_table && item.sub_table.country != null ">国家: {{ item.sub_table.country }} </p>
                              <p v-else>国家: 无</p>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.accept_at">
                          <div class="grid-content bg-purple-light">
                            <p>时间: {{ item.accept_at }} </p>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <img :src="item.image_url" alt="" width="100%" preview="1" preview-text='图片展示'>
                    </el-col>
                  </el-row>

                </div>
              </div>

            </el-checkbox>
          </template>
        </el-collapse-item>

        <el-collapse-item name="3" v-if="old_order.length">
          <template slot="title">
            旧产品信息
            <div class="old-count">{{ old_order.length }}</div>
          </template>

          <template v-for="item of old_order">
            <!--<el-checkbox :label="item.id" :key="item.id" disabled>-->

              <div class="show" :key="item.id">
                <div class="line">
                  <el-row :gutter="10">
                    <el-col :span="16">
                      <el-row>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <p v-if="item.purchase !== null">采购单号: {{ item.purchase.purchase_no }}</p>
                            <p v-else>采购单号: 待补货</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple"
                               style="color: #bd2c00">
                            <h3>多品编号</h3>
                            <p>{{ item.transaction_number }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <h3>数量</h3>
                            <p style="color:  #bd2c00">{{ item.quantity }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <h3>SKU</h3>
                            <p>{{ item.sku }}</p>
                          </div>
                        </el-col>
                        <!--            <el-col :span="12">
                                      <div class="grid-content bg-purple-light">
                                        <h3>商品中文名称</h3>
                                        <p>{{ item.product_name }}</p>
                                      </div>
                                    </el-col>-->
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{
                                item.word
                              }}</span></p>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.remark!==null">
                          <div class="grid-content bg-purple-light">
                            <p>备注: {{ item.remark }}</p>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.shelf_id!==null">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <p>货架号: {{ item.shelf.shelf_no }}</p>
                          </div>
                        </el-col>

                        <template v-else>
                          <el-col :span="24" v-if="item.history_shelf_id!==null">
                            <div class="grid-content bg-purple-light" style="color: #3967FF">
                              <p>历史货架号: {{ item.history_shelf.shelf_no }}</p>
                            </div>
                          </el-col>
                        </template>

                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未验收</span></p>
                            <p v-else-if="item.status===1">状态: <span style="color: #55a532">完成</span></p>
                            <p v-else-if="item.status===2">状态: <span style="color: red">异常</span></p>
                            <p v-else-if="item.status===3">状态: <span style="color: #3a8ee6">已拣货</span></p>
                            <p v-else-if="item.status===4">状态: <span style="color: red">锁单</span></p>
                            <p v-else-if="item.status===5">状态: <span style="color: #94971b">作废</span></p>
                            <p v-else-if="item.status===6">状态: <span style="color: #eb0fd9">缺货</span></p>
                            <p v-else-if="item.status===7">状态: <span style="color: #f00">删除</span></p>
                            <p v-else-if="item.status===8">状态: <span style="color: #123723">报废</span></p>
                            <p v-else>状态: 其它</p>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light" style="color: #3967FF">
                            <div  style="color: #3967FF">
                              <p v-if=" item.sub_table && item.sub_table.country != null ">国家: {{ item.sub_table.country }} </p>
                              <p v-else>国家: 无</p>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="24" v-if="item.accept_at">
                          <div class="grid-content bg-purple-light">
                            <p>时间: {{ item.accept_at }} </p>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="8">
                      <img :src="item.image_url" alt="" width="100%" preview="1" preview-text='图片展示'>
                    </el-col>
                  </el-row>

                </div>
              </div>

            <!--</el-checkbox>-->
          </template>
        </el-collapse-item>

      </el-collapse>

    </el-checkbox-group>

    <div v-if="items.length>0" style="margin-top:10px ;text-align: center">
      <el-checkbox
        v-model="alter"
        style="margin-right: 10px"
        border
        @change="alterShelf"
        :disabled="items_finish.length===0 && items_out_of_stock.length === 0"
      >修改货架
      </el-checkbox>
      <el-button @click="putOnShelf" type="primary" style="width: 50%">上 架</el-button>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="90%"
      top="30vh"
      :close-on-click-modal="false"
      :before-close="cancelDialog"
      center>
      <!--<span>扫描货架条码</span>-->
      <!--<span slot="footer" class="dialog-footer">-->
      <el-form class="search-box" ref="shelfForm" :model="shelfForm" :rules="rules">
        <el-form-item prop="shelf_number">
          <el-input
            ref="shelfSearch"
            @focus="stopKeyborad"
            @blur="stopKeyborad"
            v-model="shelfForm.shelf_number"
            @keydown.enter.native.prevent="doPutOn()"
            :placeholder="placeholderInfo"
          >
            <el-button
              @click.prevent="doPutOn()"
              slot="append"
              icon="el-icon-search"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <!--</span>-->
    </el-dialog>

  </div>
</template>
<style>
.up_all_item{
  width: 100%;
  text-align: center;
  margin:10px 0;
}
.el-col{
  overflow: auto;
  word-wrap: break-word; /* 超出容器自动换行 */
  overflow-wrap: break-word; /* for modern browsers */
}
.up_all_item button{
  width: 40%;
  height: 40px;
}
.group_div{
  padding: 5px;
}
.group_div .el-checkbox-group{
  width: 100%;
  display: flex;flex-wrap: wrap;
  flex-direction: column;
}
.group_div .el-checkbox-group .el-checkbox__label{
  width: 90%;
}
</style>
<script>
// import {mapState,mapMutations} from 'vuex';
// import Bus from '@/assets/js/bus';
export default {
  name: "PutOn",
  data() {
    return {
      centerDialogVisible: false,
      // remove_order: '',
      loading: false,
      form: {
        order_number: ""
      },
      shelfForm: {
        shelf_number: ""
      },
      rules: {
        order_number: [
          {required: true, message: "请扫描订单编号", trigger: "blur"},
          /*{
            type: "number",
            message: "请输入正确的订单编号",
            trigger: ["blur", "change"],
          },*/
        ],
        shelf_number: [
          {required: true, message: "请扫描货架编号", trigger: "blur"},
          /*{
            type: "number",
            message: "请输入正确的订单编号",
            trigger: ["blur", "change"],
          },*/
        ],
      },
      items: {},
      old_order: {},
      bus_item: {},
      checkboxGroup1: [],
      alter: false,  //货架修改开关
      activeNames: [],
      item_id:[],
      item_shelf_id:'',
      checkboxGroup2: [],
      item_par_id:0
    }
  },
  methods: {
    // ...mapMutations(['setShelf']),
    //子集集合上架
    putOnShelfSons(arr){
      var _this = this;
      let is_item_id = [];

      //判断子集
      if(_this.checkboxGroup2.length>0){
        let item_par_id = 0;
        for (var i in arr){
          if( _this.checkboxGroup2.includes(arr[i].id) ){
            is_item_id.push(arr[i].id);
            item_par_id = arr[i].purchase_detail_id;
          }
        }
        if(item_par_id!=0){
          _this.item_par_id = item_par_id;
          _this.item_id = is_item_id;
          _this.putOnShelf();
        }
      }


    },
    // 子集上架
    putOnShelfSon(id,item_par_id){
      this.item_id = [];
      this.item_id.push(id);
      this.item_par_id = item_par_id;
      this.putOnShelf();
    },
    //修改货架操作
    alterShelf(val) {

      if (val) {
        if (!this.activeNames.includes("1")) {
          this.activeNames.push("1");
        }

        for (let i = 0; i < this.items_finish.length; i++) {
          this.checkboxGroup1.push(this.items_finish[i].id)

        }
        //对按数量验收单进行改货架号
        for (let i = 0; i < this.items_out_of_stock.length; i++) {
          if(this.items_out_of_stock[i].shelf_id != null){
            this.checkboxGroup1.push(this.items_out_of_stock[i].id)
          }
        }

      } else {
        for (let i = 0; i < this.items_finish.length; i++) {
          let index = this.checkboxGroup1.indexOf(this.items_finish[i].id);
          this.checkboxGroup1.splice(index, 1)

        }
        //对按数量验收单进行取消改货架号
        for (let i = 0; i < this.items_out_of_stock.length; i++) {
          let index = this.checkboxGroup1.indexOf(this.items_out_of_stock[i].id);
          this.checkboxGroup1.splice(index, 1)

        }
      }
      // console.log(this.checkboxGroup1);
      // console.log(this.activeNames)
    },

    //上架
    putOnShelf() {
      let id = this.item_id;
      let item_par_id = this.item_par_id

      console.log(id,item_par_id)
      if (this.checkboxGroup1.length === 0 && id.length<=0) {
        const h = this.$createElement;
        this.$message({
          offset: 50,
          duration: 3000,
          message: h('p', null, [
            h('span', null, '请选择要上架的产品'),
            // h('i', { style: 'color: teal' }, 'VNode')
          ])
        });

        return false
      }

      this.centerDialogVisible = true

      //加定时器
      this.$nextTick(() => {
        // this.$refs.shelfSearch.focus()
        this.shelfOnfocusEvent()
      })
    },
    //添加货架操作
    doPutOn() {
      console.log(this.checkboxGroup1)
      console.log(this.shelfForm.shelf_number)

      //判断不是是修改货架操作,执行检测
      if (!this.alter) {
        if (this.shelf_name !== "") {
          if (this.shelfForm.shelf_number !== this.shelf_name) {
            this.$message.error(this.shelfForm.shelf_number + ' 与指定货架不一致')
            this.shelfOnfocusEvent()
            this.shelfForm.shelf_number = ""
            return false
          }
        }
      }


      let param = {
        order_number: this.items[0].order_number,
        order_ids: this.checkboxGroup1,
        shelf_number: this.shelfForm.shelf_number
      }

      if(this.item_id.length>0){
        let ord_ids = [];
        ord_ids.push(this.item_par_id)
        param = {
          order_number: this.items[0].order_number,
          order_ids: ord_ids,
          shelf_number: this.shelfForm.shelf_number,
          item_id:this.item_id
        }
      }

      this.$refs.shelfForm.validate((valid) => {
        if (valid) {
          // this.loading = true
          this.http.fetchPost(this.api.putOnShelf, param).then((res) => {
            console.log(res)
            // this.loading = false

            var data = res.data;
            if (data.code === 200) {
              const h = this.$createElement;
              this.$message({
                offset: 50,
                duration: 3000,
                message: h('p', null, [
                  h('span', null, '上架成功 ' + data.data.shelf_number),
                  // h('i', { style: 'color: teal' }, 'VNode')
                ])
              });

              this.centerDialogVisible = false
              this.checkboxGroup1 = []
              this.checkboxGroup2 = []
              this.item_id = []
              this.item_par_id=0
              this.alter = false
              this.refreshShelf()
            } else {
              this.$message.error(this.shelfForm.shelf_number + " " + data.message)
            }
            this.shelfForm.shelf_number = ''


          }).catch((err) => {
            console.log(err);
            // this.form.order_number = ""
            // this.onfocusEvent()
            this.shelfForm.shelf_number = ''
            this.shelfOnfocusEvent()
            this.$message.error('扫描货架号错误');
            // this.loading = false
          });
        } else {
          // this.$message.error('请输入账号和密码');
          console.log("error submit!!");
          return false;
        }
      });


    },

    //上架之后更新数据
    refreshShelf() {
      this.onfocusEvent()

      var instId = this.$route.query.order_number
      if (instId !== undefined) {
        this.refresh(instId)
      }
    },


    onSubmit() {

      this.checkboxGroup1 = []

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          this.http.fetchGet(this.api.product + "/2/" + this.form.order_number).then((res) => {
            // this.loading = false
            var data = res.data;
            console.log(data)
            if (data.code === 200) {

              // let lists = data.data;
              // this.remove_order = this.form.order_number
              this.items = data.data.products
              this.old_order = data.data.old_order
              this.checkboxGroup1 = []
              this.form.order_number = ""
              this.alter = false
              this.onfocusEvent()
              this.activeNames = []

              if (this.items_wait.length === 0 && this.items_out_of_stock.length === 0) {
                this.activeNames.push("1");
              }

              //自动展开按数量验收
              if (this.items_out_of_stock.length !== 0) {
                if (!this.activeNames.includes("4")) {
                  this.activeNames.push("4");
                }
              }

              //更改地址参数
              const query = JSON.parse(JSON.stringify(this.$route.query))
              query.order_number = this.items[0].order_number
              this.$router.push({path: this.$route.path, query})

            } else {
              this.$message.error(data.message);
              this.form.order_number = ""
              this.onfocusEvent()
            }

            this.loading = false
            // 请求成功处理
          }).catch((err) => {
            console.log(err);
            this.form.order_number = ""
            this.onfocusEvent()
            this.$message.error('扫描订单号错误');
            this.loading = false
          });
        } else {
          // this.$message.error('请输入账号和密码');
          console.log("error submit!!");
          return false;
        }
      });

    },

    //更新列表数据
    refresh(number) {
      this.http.fetchGet(this.api.product + "/2/" + number).then((res) => {
        // console.log(res)
        // this.loading = false
        var data = res.data;
        // console.log(data)
        if (data.code === 200) {
          // let lists = data.data;
          // this.remove_order = number
          this.items = data.data.products
          this.old_order = data.data.old_order
          this.checkboxGroup1 = []
          this.form.order_number = ""
          this.alter = false
          this.onfocusEvent()

          if (this.items_wait.length === 0 && this.items_out_of_stock.length === 0) {
            if (!this.activeNames.includes("1")) {
              this.activeNames.push("1");
            }
          }
          //自动展开按数量验收
          if (this.items_out_of_stock.length !== 0) {
            if (!this.activeNames.includes("4")) {
              this.activeNames.push("4");
            }
          }


        } else {
          this.$message.error(data.message);
          this.form.order_number = ""
          this.onfocusEvent()
        }

        // this.loading = false
        // 请求成功处理
      }).catch((err) => {
        console.log(err);
        this.form.order_number = ""
        this.onfocusEvent()
        // this.loading = false
      });
    },

    openDialog() {
      //提示标记发货弹窗
      let open = true;
      for (let i = 0; i < this.items.length; i++) {
        console.log(this.items[i])
        if (this.items[i].status !== 1) {
          open = false;
          break;
        }
      }

      if (open) {
        this.centerDialogVisible = true
      }
    },

    cancelDialog() {
      this.centerDialogVisible = false
      this.shelfForm.shelf_number = ''
      this.onfocusEvent()
    },

    //扫描货架自动获取光标
    shelfOnfocusEvent() {
      this.$refs.shelfSearch.focus()
    },

    //自动获取光标
    onfocusEvent() {
      this.$refs.search.focus()
    },
    stopKeyborad(e) {
      //尝试一下
      e.target.setAttribute('readonly', true);
      setTimeout(() => {
        e.target.removeAttribute('readonly');
      }, 100);
    },

  },
  computed: {
    //货架分区
    partition_name() {
      if (this.items.length > 0) {
        for (let item of this.items) {
          if (item.partition != null) {
            return item.partition.name
          }
        }
      } else if (this.old_order.length > 0) {
        for (let item of this.old_order) {
          if (item.partition != null) {
            return item.partition.name
          }
        }
      }

      return ""
    },
    //货架编号
    shelf_name() {
      if (this.items.length > 0) {
        for (let item of this.items) {
          if (item.shelf !== null) {
            return item.shelf.shelf_no
          }
        }
      } else if (this.old_order.length > 0) {
        for (let item of this.old_order) {
          if (item.shelf !== null) {
            return item.shelf.shelf_no
          }
        }
      }

      return ""
    },

    //待上架产品
    items_wait() {
      let arr = []
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].status === 1 && this.items[i].shelf_id === null) {
          arr.push(this.items[i])
        }
      }
      return arr
    },

    //在货架产品
    items_finish() {
      let arr = []
      for (let i = 0; i < this.items.length; i++) {
        if ( this.items[i].status === 1 && this.items[i].shelf_id !== null ) {
          arr.push(this.items[i])
        }
      }
      return arr
    },
    //未验收/异常/已发货产品
    items_unfinished() {
      let arr = []
      for (let i = 0; i < this.items.length; i++) {
        if ( (this.items[i].status !== 1 && this.items[i].status !== 6 && this.items[i].detail_items.length<=0) || ( this.items[i].detail_items.length>0 && (this.items[i].status == 3) ) ) {
          arr.push(this.items[i])
        }
      }
      console.log(arr);
      return arr
    },
    //按数量验收，且未完成的订单（补货单)
    items_out_of_stock() {
      let arr = []
      for (let i = 0; i < this.items.length; i++) {
        if ( this.items[i].detail_items.length>0 && ( this.items[i].status == 6 || this.items[i].status == 4 )) {
          arr.push(this.items[i])
        }
      }
      return arr
    },
    // 上架提示信息
    placeholderInfo() {
      return this.alter ? "扫描变更到的货架" : this.shelf_name ? "扫描货架：" + this.shelf_name : "扫描货架"
    }
  },
  /*watch: {
    $route: { // 监听路由的参数变化
      handler() { // 数据变化更新数据
        var instId = this.$route.query.order_number
        if (instId !== undefined) {
          this.refresh(instId)
        }
      },
      immediate: true // 立即执行
    }
  },*/

  /*beforeDestroy() {
    this.$EventBus.$emit('order', this.bus_item);
  },*/

  //被 keep-alive 缓存的组件失活时调用
  deactivated() {
    this.$EventBus.$emit('order', this.bus_item);
  },

  //被 keep-alive 缓存的组件激活时调用
  activated() {
    // console.log(23456)
    this.onfocusEvent()

    var instId = this.$route.query.order_number
    if (instId !== undefined) {
      this.refresh(instId)
    }

  },
  /*mounted() {
    // alert(123)
    this.onfocusEvent()
  }*/

}
</script>

<style scoped lang="stylus">

.el-checkbox
  margin-top 10px
  margin-right 0

.el-checkbox >>> .el-checkbox__input
  vertical-align: top

.is-checked .show
  background-color #a4c9f1
  color #606266

.show {
  //float: left;
  width: 96%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 99%;

    .el-col {
      margin-top 3px
      margin-bottom: 3px;
      padding 0 5px

      &:last-child {
        //margin-bottom: 0;
      }
    }

    .grid-content {
      //text-align center

      h3 {
        font-size 14px
      }
    }

  }
}


.old-count
  margin-left: 5px;
  width: 20px;
  height: 20px;
  background-color: #ea4444;
  line-height: 20px;
  text-align: center;
  color: white;
  border-radius: 10px


</style>
